<template>
  <div class="contents contents--pt">
    <section class="Form _min-h">
      <div class="inner">
        <div class="Form--pt">
          <p class="Form__tx Form__tx--mb_sm">
            変更後のお名前をご入力ください。
          </p>
          <div class="Form__area">
            <div :class="`Form__input_box Form__input_box--mb_md Form__input_box--md ${$v.userInfo.last_name.$error ? '_error' : ''}`">
              <div class="Form__input_heda Form__input_head_required Form__input_head_required_tx_box">
                姓<span class="Form__input_head_required_tx">*必須</span>
              </div>
              <input
                v-model.trim="$v.userInfo.last_name.$model"
                class="Form__input"
                type="text"
                placeholder="舐瓜"
                required
              >
              <div class="Form__error_box">
                <div class="Form__error_tx">
                  <label v-if="!$v.userInfo.last_name.required">姓を入力してください</label>
                  <label v-if="!$v.userInfo.last_name.maxLength">姓を入力の最大長255</label>
                </div>
              </div>
            </div>
            <div :class="`Form__input_box Form__input_box--md ${$v.userInfo.first_name.$error ? '_error' : ''}`">
              <div class="Form__input_heda Form__input_head_required">
                名
              </div>
              <input
                v-model.trim="$v.userInfo.first_name.$model"
                class="Form__input"
                type="text"
                placeholder="太郎"
                required
              >
              <div class="Form__error_box">
                <div class="Form__error_tx">
                  <label v-if="!$v.userInfo.first_name.required">名を入力してください</label>
                  <label v-if="!$v.userInfo.first_name.maxLength">名を入力の最大長255</label>
                </div>
              </div>
            </div>
            <button :disabled="$v.userInfo.$invalid || isLoading" class="Btn__blue Form__btn Form__btn--sm_sp Form__btn--mt_md Form__btn--mt_lg Form__btn--mt_sp_lg" @click="updateUserInfo()">
              変更する
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import authService from '@/services/authService'
import { required, maxLength } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { redirect } from '@/helpers'
const validations = {
  userInfo: {
    first_name: {
      required,
      maxLength: maxLength(255)
    },
    last_name: {
      required,
      maxLength: maxLength(255)
    }
  }
}
export default {
  name: 'ChangeName',
  mixins: [validationMixin],
  data() {
    return {
      userInfo: {
        first_name: '',
        last_name: ''
      },
      isLoading: false,
      showError: false
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await this.getUserInfo()
    },
    async getUserInfo() {
      this.$store.dispatch('loading/updateLoading', true)
      const response = await authService.getUserInfo()
      const userInfoData = response.user.user
      this.userInfo.first_name = userInfoData.first_name
      this.userInfo.last_name = userInfoData.last_name
      this.$store.dispatch('loading/updateLoading', false)
    },
    async updateUserInfo() {
      this.$v.userInfo.$touch()
      if (this.$v.userInfo.$invalid) {
        return
      }
      const redirectPath = '/change/name/thanks'
      this.$store.dispatch('loading/updateLoading', true)
      await authService.updateUserInfo(this.userInfo)
      this.$store.dispatch('loading/updateLoading', false)
      redirect(redirectPath)
    }
  },
  validations: validations
}
</script>
